(() => {
  if(document.querySelectorAll('.cookies-disclaimer').length){
    if (!localStorage.getItem('cookie_disclaimer')) {
      document.querySelector('.cookies-disclaimer').classList.remove('hidden');
    }

    document.querySelector('.cookies-disclaimer-close').addEventListener('click', function(event){
      event.preventDefault();
      document.querySelector('.cookies-disclaimer').classList.add('hidden');
      localStorage.setItem('cookie_disclaimer', true);
    });
  }    
})();